import moment from "moment";

export const defaultLineBarChartConfig = {
    type: "line",
    height: 350,
    series: [
        {
            name: "가입수",
            type: "column",
            data: [],
        },
    ],
    options: {
        chart: {
            toolbar: {
                show: true,
                tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: true,
                    reset: false
                }
            },
            zoom: {
                enabled: true
            }
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    total: {
                        enabled: true,
                        style: {
                            fontSize: "13px",
                            fontWeight: 900,
                        },
                    },
                    position: "top",
                },
            },
        },
        stroke: {
            width: [4],
        },
        dataLabels: {
            enabled: true,
            background: false,
            offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#008ffb"],
            },
        },
        xaxis: {
            type: "date",
        },
        yaxis: {
            labels: {
                formatter: (value) => {
                    return Math.floor(value);
                },
            },
        },
    },
};

export const defaultPieChartConfig = {
    type: "pie",
    height: 250,
    series: [],
    options: {
        chart: {
            width: 250,
            type: "pie",
        },
        colors: [
            "#62B2FD",
            "#9BDFC4",
            "#F99BAB",
            "#FFB44F",
            "#a3e635",
            "#6ee7b7",
            "#67e8f9",
            "#93c5fd",
            "#a78bfa",
            "#f472b6",
            "#53836d",
            "#7283f4",
            "#b6e733",
            "#d03520",
            "#800d0d",
            "#2bb65b",
            "#055964",
            "#480264",
            "#8a06f5",
            "#fffe7e",
        ],
        labels: [],
        legend: {
            show: false,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                },
            },
        ],
    },
};

export const defaultBarChartConfig = {
    type: "line",
    height: 350,
    series: [
        {
            name: "혜택 발급수",
            type: "column",
            data: [],
        },
        {
            name: "혜택 사용수",
            type: "column",
            data: [],
        },
    ],
    options: {
        chart: {
            toolbar: {
                show: true,
                tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: true,
                    reset: false
                }
            },
            zoom: {
                enabled: true
            }
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    total: {
                        enabled: true,
                        style: {
                            fontSize: "13px",
                            fontWeight: 900,
                        },
                    },
                    position: "top",
                },
            },
        },
        fill: {
            opacity: [0.85, 0.5],
            gradient: {
                inverseColors: false,
                shade: "light",
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100],
            },
        },
        stroke: {
            width: [4, 4],
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#008ffb", "#00e397"],
            },
        },
        xaxis: {
            type: "date",
        },
        yaxis: [
            {
                title: {
                    text: "혜택 발급수 / 혜택 사용수",
                },
                type: "numeric",
                labels: {
                    formatter: (value) => {
                        return Math.floor(value);
                    },
                },
            },
        ],
    },
};

export const userBarChartConfig = {
    type: "line",
    height: 350,
    series: [
        {
            name: "발송수",
            type: "column",
            data: [],
        },
        {
            name: "클릭수",
            type: "column",
            data: [],
        },
    ],
    options: {
        chart: {
            toolbar: {
                show: true,
                tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: true,
                    reset: false
                }
            },
            zoom: {
                enabled: true
            }
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    total: {
                        enabled: true,
                        style: {
                            fontSize: "13px",
                            fontWeight: 900,
                        },
                    },
                    position: "top",
                },
            },
        },
        fill: {
            opacity: [0.85, 0.5],
            gradient: {
                inverseColors: false,
                shade: "light",
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100],
            },
        },
        stroke: {
            width: [4, 4],
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#008ffb", "#00e397"],
            },
        },
        xaxis: {
            type: "category",
        },
        yaxis: [
            {
                title: {
                    text: "",
                },
                labels: {
                    formatter: (value) => {
                        return Math.floor(value);
                    },
                },
            },
        ],
    },
};

export const userLineChartConfig = {
    type: "line",
    height: 350,
    series: [
        {
            name: "클릭수",
            type: "line",
            color: "#ff9930",
            data: [],
        },
    ],
    options: {
        chart: {
            toolbar: {
                show: true,
                tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: true,
                    reset: false
                }
            },
            zoom: {
                enabled: true
            }
        },
        stroke: {
            width: [3],
        },
        dataLabels: {
            enabled: true,
            background: {
                enabled: false
            },
            offsetY: -10,
            style: {
                fontSize: "12px",
                colors: ["#ff9930"],
            },
            formatter: function (value) {
                return value === 0 ? '' : value;
            }
        },
        xaxis: {
            type: "category",
            labels: {
                formatter: (value) => {
                    return moment(new Date(value)).format("DD일 HH:00")
                }
            }
        },
        yaxis: {
        },
    },
};


export const basicBarOption = (xAxis, series, unit = "") => {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow', // 'line' | 'shadow'
            },
            formatter: (params) => {
                return params.map( (item) =>
                    `${item.name}<br/>${item.marker} ${item.value}${unit}${item.data?.extraInfo ?? ""}`
                ).join('<br/>')
            },
        },
        xAxis: {
            type: 'category',
            data: xAxis ?? [],
        },
        yAxis: {
            type: 'value',
            minInterval: 1
        },
        dataZoom: [
            {
                type: 'slider', // 줌 슬라이더 추가
                start: 0, // 초기 시작 위치
                end: 100, // 초기 종료 위치
            },
        ],
        series: [
            {
                data: series ?? [],
                type: 'bar',
                barWidth: '50%',
                itemStyle: {
                    borderRadius: [6, 6, 0, 0]
                },
                label: {
                    show: true, // 라벨 표시
                    position: 'top', // 라벨 위치: 'top', 'inside', 'left', 'right' 등
                    color: '#000', // 라벨 색상
                    fontSize: 14, // 라벨 폰트 크기,
                    formatter: (params) => {
                        return params.value === 0 ? '' : `${params.value}${unit}`; // 0일 경우 빈 문자열 반환
                    },
                },
            },
        ],
    }
}


/**
 * 파랑 단색 램프(연함 → 진함). 값의 크기를 색으로 나타낼 때 쓴다.
 *
 * 🔴 **여러 색(빨주노초파남보)을 크기에 쓰면 안 된다** — 무지개 램프는 "어느 쪽이 큰가" 를
 * 알려주지 못하고(색상 순서는 사람이 학습한 것이 아니다) 화면이 시끄러워진다.
 * 2026-09-11 사용자 피드백("너무 원색이다, 차분하게, weight 별 그라데이션")의 정확한 처방이
 * 이것이다 — **크기 = 한 색의 진하기**.
 *
 * 값은 검증된 파랑 계열 램프의 250~650 단계다. 🔑 250 보다 연한 단계는 쓰지 않는다 —
 * 흰 카드 배경(#fff)에서 막대가 배경에 묻어 "값이 0인가" 로 보인다.
 */
export const SEQUENTIAL_BLUE = [
    "#86b6ef", "#6da7ec", "#5598e7", "#3987e5", "#2a78d6",
    "#256abf", "#1c5cab", "#184f95", "#104281",
]

/**
 * 히트맵용 램프. 0에 가까운 칸은 **배경으로 물러나야** 하므로 막대보다 연한 단계까지 쓴다
 * (히트맵은 칸이 맞닿아 있어서 연한 색도 경계로 읽힌다 — 막대와 사정이 다르다).
 */
export const SEQUENTIAL_BLUE_WIDE = [
    "#eef5fd", "#cde2fb", "#b7d3f6", "#9ec5f4", "#86b6ef",
    "#5598e7", "#3987e5", "#2a78d6", "#256abf", "#1c5cab", "#104281",
]

/**
 * 범주(성별 등)용 색. **검증된 팔레트의 앞 3슬롯**(파랑·주황·청록)이다.
 *
 * 🔑 앞 3슬롯만 쓰는 이유 = 그 셋이 색약 시뮬레이션에서 **모든 짝**이 분리 기준을 통과한다
 * (4번째 노랑이 들어오면 주황과 겹친다). 성별은 여성·남성·미수집 3개라 정확히 맞는다.
 * ⚠️ 청록(`#1baf7a`)은 흰 배경 대비가 3:1 미만이다 → **범례 문구가 반드시 함께 있어야 한다**
 *    (색만으로 구분하지 않는다). 아래 [pieOption] 의 범례가 그 역할을 한다.
 */
export const CATEGORICAL_COLORS = ["#2a78d6", "#eb6834", "#1baf7a"]

/** 축·격자·글자 색(차분한 회색 계열). ECharts 기본값은 이 화면에서 너무 진하다. */
const AXIS_INK = "#898781"
const GRID_LINE = "#e1e0d9"

/**
 * 값 크기에 따라 [SEQUENTIAL_BLUE] 한 단계를 고른다.
 *
 * @param value 이 막대의 값
 * @param max 같은 차트에서 가장 큰 값. 0 이면 전부 가장 연한 단계.
 *
 * 🔑 **차트 안에서의 상대 크기**로 정한다. 절대값 기준으로 하면 값이 고르게 작은 차트가
 *    전부 연한 색이 되어 분포가 안 보인다.
 */
export const sequentialStep = (value, max) => {
    if (!max || max <= 0) return SEQUENTIAL_BLUE[0]
    const ratio = Math.max(0, Math.min(1, (value ?? 0) / max))
    return SEQUENTIAL_BLUE[Math.round(ratio * (SEQUENTIAL_BLUE.length - 1))]
}

/**
 * 분포(연령대 · 가입 시간대 · 가입 요일) 막대그래프 옵션.
 *
 * [basicBarOption] 을 그대로 쓰고 다음을 바꾼다:
 *  1. `dataZoom` 제거 — 구간이 7~13개로 고정이라 슬라이더가 조작할 것이 없다.
 *  2. `axisLabel.interval = 0` — ECharts 는 라벨이 겹치면 **말없이 건너뛴다.**
 *     반쪽 폭에 구간이 13개까지 들어가므로 45도로 눕히고 전부 표시한다.
 *  3. **값 크기 = 색의 진하기**([sequentialStep]).
 *  4. **툴팁에 절대 인원을 함께** 보여준다(2026-09-11 사용자 요청).
 *     🔴 퍼센트만으로는 인원을 역산할 수 없다 — 분포마다 분모가 다르고(나이대는 생년이 있는
 *     고객만) 반올림도 들어가 있다. 그래서 서버가 `*Counts` 를 따로 내려준다.
 *
 * @param counts 같은 순서의 인원 배열. 없으면 퍼센트만 보여준다(구 응답 호환).
 */
export const distributionBarOption = (xAxis, series, counts = null, unit = "%") => {
    const option = basicBarOption(xAxis, series, unit)
    const values = series ?? []
    const max = values.length > 0 ? Math.max(...values) : 0

    delete option.dataZoom

    option.xAxis = {
        ...option.xAxis,
        axisLabel: { interval: 0, rotate: 45, fontSize: 10, color: AXIS_INK },
        axisLine: { lineStyle: { color: GRID_LINE } },
        axisTick: { show: false },
    }
    option.yAxis = {
        ...option.yAxis,
        axisLabel: { color: AXIS_INK, fontSize: 10 },
        splitLine: { lineStyle: { color: GRID_LINE } },
    }
    option.grid = { left: 0, right: 8, top: 28, bottom: 0, containLabel: true }

    option.series[0].data = values.map((value, index) => ({
        value,
        itemStyle: { color: sequentialStep(value, max) },
    }))
    option.series[0].barWidth = "60%"
    // 막대 위 숫자는 퍼센트만(인원은 툴팁에서 본다 — 둘 다 얹으면 읽을 수 없다).
    option.series[0].label = { ...option.series[0].label, color: AXIS_INK, fontSize: 10 }

    option.tooltip = {
        ...option.tooltip,
        formatter: (params) => params.map((item) => {
            const count = counts?.[item.dataIndex]
            const people = count != null ? ` · <b>${count.toLocaleString()}명</b>` : ""
            return `${item.name}<br/>${item.marker} ${item.value}${unit}${people}`
        }).join("<br/>"),
    }

    return option
}

/**
 * 가입 요일 × 가입 시간대 히트맵.
 *
 * @param xLabels 시간대(가로), @param yLabels 요일(세로)
 * @param cells `[xIndex, yIndex, count]` 배열. **0건 칸도 넣어야** 빈칸이 격자로 보인다.
 * @param max 색 스케일 상단. 필터를 바꿔도 **스케일이 요동치지 않게** 호출부가 정한다.
 *
 * 🔑 세로를 요일로 둔 이유 = 요일 7개 < 시간대 13개. 가로로 긴 화면에 맞고,
 *    "월요일 줄을 따라 읽기" 가 사람의 읽는 방향과 같다.
 */
export const heatmapOption = (xLabels, yLabels, cells, max) => ({
    tooltip: {
        position: "top",
        formatter: (p) => {
            const [x, y, v] = p.value
            return `${yLabels[y]} ${xLabels[x]}<br/><b>${(v ?? 0).toLocaleString()}명</b>`
        },
    },
    grid: { left: 0, right: 8, top: 8, bottom: 48, containLabel: true },
    xAxis: {
        type: "category",
        data: xLabels,
        splitArea: { show: true },
        axisLabel: { interval: 0, rotate: 45, fontSize: 10, color: AXIS_INK },
        axisLine: { lineStyle: { color: GRID_LINE } },
        axisTick: { show: false },
    },
    yAxis: {
        type: "category",
        data: yLabels,
        /*
          🔴 `inverse` 없이는 **월요일이 맨 아래**로 간다(ECharts 카테고리 축은 아래에서
             위로 쌓는다). 달력·시간표는 위에서 아래로 읽으므로 뒤집는다 —
             스크린샷으로 보고서야 알았다(옵션만 봐서는 드러나지 않는다).
        */
        inverse: true,
        splitArea: { show: true },
        axisLabel: { fontSize: 10, color: AXIS_INK },
        axisLine: { lineStyle: { color: GRID_LINE } },
        axisTick: { show: false },
    },
    visualMap: {
        min: 0,
        // 🔑 상한이 0 이면 ECharts 가 색을 못 고른다(전 구간이 한 점이 된다) → 최소 1.
        max: Math.max(1, max ?? 1),
        calculable: false,
        orient: "horizontal",
        left: "center",
        bottom: 0,
        itemHeight: 80,
        textStyle: { color: AXIS_INK, fontSize: 10 },
        inRange: { color: SEQUENTIAL_BLUE_WIDE },
    },
    series: [{
        type: "heatmap",
        data: cells,
        // 칸 사이 1px 흰 선 — 맞닿은 색이 서로 번지지 않게 한다.
        itemStyle: { borderColor: "#ffffff", borderWidth: 1 },
        emphasis: { itemStyle: { borderColor: "#0b0b0b", borderWidth: 1 } },
        progressive: 0,
    }],
})

export const pieOption = (name, series, unit = "", center = ["30%", "50%"]) => {
    /*
      각 항목의 `count`(절대 인원)가 있으면 툴팁에 함께 보여준다(2026-09-11).
      🔑 없을 때는 종전과 똑같이 퍼센트만 나온다 — 이 함수를 쓰는 다른 화면(획득 고객 등)은
         인원을 넘기지 않으므로 그쪽 문구가 바뀌면 안 된다.
    */
    const countOf = (itemName) => (series ?? []).find((d) => d?.name === itemName)?.count

    return {
        tooltip: {
            trigger: 'item',
            formatter: (item) => {
                const count = countOf(item.name)
                const people = count != null ? ` · <b>${count.toLocaleString()}명</b>` : ""
                return `${item.name}<br/>${item.marker} ${item.value}${unit}${people}`
            },
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 'right',
            formatter: function(name) {
                if (series.length > 0) {
                    let value = 0;
                    for (let i = 0; i < series.length; i++) {
                        const data = series[i]
                        if (data.name === name) {
                            value = data.value;
                            break;
                        }
                    }
                    return `${name} (${value}${unit})`;
                }
                return name
            },
        },
        // 🔑 범주 색을 명시한다(2026-09-11). ECharts 기본 팔레트는 이 화면의 막대 램프와
        //    색 체계가 달라 두 카드가 남처럼 보였다. 검증된 앞 3슬롯을 쓴다.
        color: CATEGORICAL_COLORS,
        series: [
            {
                name: name,
                type: 'pie',
                radius: '50%',
                center: center,
                data: series ?? [],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            },
        ],
    }
};